/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  // readRequest2: ["userId"],
  posts2Request: ["options"], // userId
  posts2Success: ["response"],
  posts2Failure: ["response"]
/*
  postDetailsRequest: ["userId"],
  postDetailsSuccess: ["response"],
  postDetailsFailure: ["response"]
*/
})

export const PostDetailsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  modified: null,
  fetching: null,
  error: null,
  posts: []
})

/* ------------- Reducers ------------- */

// read posts
// export const readRequest2 = (state, action) => {
export const posts2Request = (state, action) => {

  const { userId } = action
  return state.merge({ fetching: true, error: null })
}

// successful read posts
export const posts2Success = (state = {}, action) => {

// export const postDetailsSuccess = (state = {}, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const posts = apiResponse.data
  // const token = apiResponse.accessToken
  // console.tron.display({
  //   name: 'readSuccess2',
  //   preview: 'You should totally expand this',
  //   value: {
  //     action: action,
  //     response: response,
  //     dlevery: user.Addresses
  //   }
  // })
  // let newUser = user.map((x, index) => {
  //   return [
  //     ...x]
  // })
  //(new Date()).getTime()
  return state.merge({ fetching: false, modified: null, posts: posts })
}

// failed read posts
export const posts2Failure = (state, action) => {
  console.tron.log("postsFailure begins");
// export const postDetailsFailure = (state, action) => {
  const { response } = action
  // console.tron.display({
  //   name: 'readFailure',
  //   preview: 'You should totally expand this',
  //   value: {
  //     state: state,
  //     action: action,
  //     response: response,
  //   }
  // })
  // const { data  : {errors}} = response
  //     const {fieldErrors} = errors[0]
  //     const error = fieldErrors[0]

  return state.merge({ fetching: false, error: null })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  // ***** warning: constant must closely match function name, or get 'uncaught at check, pattern channel undefined'
  // [Types.READ_REQUEST2]: readRequest2,
  // [Types.POSTS_REQUEST7]: postsRequest7, // works
  // [Types.POSTDETAILS_REQUEST]: postDetailsRequest, // fails, something special about that name????
  [Types.POSTS2_REQUEST]: posts2Request,
  [Types.POSTS2_SUCCESS]: posts2Success,
  [Types.POSTS2_FAILURE]: posts2Failure
/*
  [Types.POSTDETAILS_REQUEST]: postDetailsRequest,
  [Types.POSTDETAILS_SUCCESS]: postDetailsSuccess,
  [Types.POSTDETAILS_FAILURE]: postDetailsFailure
*/
})
